export type ChatMessagePreviewFields = {
  content: string;
  image_url?: string | null;
  type?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  sender_name?: string | null;
};

const MAX_PREVIEW_BODY_LENGTH = 60;

function truncatePreview(text: string): string {
  if (text.length <= MAX_PREVIEW_BODY_LENGTH) return text;
  return `${text.slice(0, MAX_PREVIEW_BODY_LENGTH - 1)}…`;
}

function getPreviewBody(message: ChatMessagePreviewFields): string | null {
  const text = message.content?.trim();
  if (text) return truncatePreview(text);
  if (message.image_url) return 'Photo';
  if (message.type === 'pdf' || message.file_url) return 'PDF';
  return null;
}

export function formatChatMessagePreview(
  message: ChatMessagePreviewFields | null | undefined
): string {
  if (!message) return 'No messages yet';

  const body = getPreviewBody(message);
  if (!body) return 'No messages yet';

  const sender = message.sender_name?.trim();
  if (!sender) return body;

  return `${sender}: ${body}`;
}
